import { render } from "./Topbar.vue?vue&type=template&id=5f8e0ebe&scoped=true&ts=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import "./topbar.scss?vue&type=style&index=0&id=5f8e0ebe&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8e0ebe"]])

export default __exports__